<template>
  <div class="">
    <!-- header start -->
    <van-nav-bar
      title="时空信箱"
      right-text="发表"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      @click-right="onClickRight"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div>
      <van-field
        v-model="input.Content"
        rows="5"
        autosize
        type="textarea"
        maxlength="300"
        placeholder="发表时空信箱..."
        show-word-limit
      />
      <div class="image-uploader">
        <van-uploader
          :after-read="afterRead"
          @delete="deleteImg"
          v-model="fileList"
          multiple
          :max-count="9"
        />
      </div>

      <van-tabs v-model="active">
          <van-tab
            v-for="item in classList"
            :key="item.ClassID"
            :title="item.ClassName"
            >
              <CustomRemarkItem  @changContent="onChangContent" :tid="item.ClassID" ></CustomRemarkItem>
            </van-tab
          >
        </van-tabs>
    </div>

    <div class="btn-area" style="margin: 0px 4px;">
      <van-button @click="onClickRight()" class="mybtn" block>发表</van-button>
    </div>
    <br />
    <br />
  </div>
</template>

<script>
import CustomRemarkItem from "../../../components/CustomRemarkItem.vue";
import { mapGetters } from "vuex";
import { Toast } from "vant";
export default {
  data() {
    return {
      message: "",
      fileList: [
        // { url: 'https://img.yzcdn.cn/vant/leaf.jpg' },
        // { url: 'https://cloud-image', isImage: true },
      ],
      input: {
        MemorialHallID: "",
        Content: "",
        Base64ContentList: [],
      },
      isAdd: false,
      active: 2,
      classList: null
    };
  },
  computed: {
    ...mapGetters(["currentToken"]),
  },
  mounted() {},
  components: {
    CustomRemarkItem
  },
  beforeRouteEnter(to, from, next) {
    console.log(from.name);
    // if (from.name == "Login") {
    //     next(-1);
    // }
    // else{
    //   next();
    // }
    next();
  },
  methods: {
    init() {
      var that = this;
      this.$store
        .dispatch({
          type: "getCustomRemarkClassList",
        })
        .then((res) => {
          that.classList = res;
        });
    },
    onChangContent(content){
        this.input.Content=content;
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      // console.log(this.input);
      // console.log(this.$store.state.account.isLogin);
      // console.log(this.$route.query);
      var that = this;
      var postData = this.input;
      if (postData.Content == "") {
        Toast("发表内容不能为空！");
        return false;
      }
      if (!this.$store.state.account.isLogin) {
        this.$router.push("/login?ReturnUrl=" + this.$route.fullPath);
      } else {
        Object.assign(postData, {
          type: "getMailBoxMailBoxAddVue",
        });
        that.$store.dispatch(postData).then(
          (res) => {
            console.log(res);
            Toast(res.Message);
            if (res.IsSuccess) {
              that.$router.go(-1);
              // that.$router.replace({
              //   path:"/Mailbox",
              //   query:that.$route.query
              // })
            }
          },
          (error) => {
            //console.log(error);
            if (error.status == 401) {
              Toast("请登录后再进行发表留言！");
            }
          }
        );
      }
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      var that = this;
      if (file.length != null && file.length > 0) {
        file.forEach((element) => {
          that.input.Base64ContentList.push(element.content);
        });
      } else {
        that.input.Base64ContentList.push(file.content);
      }
    },
    deleteImg(file) {
      var that = this;
      that.input.Base64ContentList.splice(
        that.input.Base64ContentList.indexOf(file.content),
        1
      );
    },
    getMemorialHall(id) {
      var that = this;
      that.$store
        .dispatch({
          type: "GetMemorialHallSearchApiById",
          id: id,
        })
        .then(
          (res) => {
            var memorialHallapiModel = res.MemorialHallSearchApiModel;

            if (memorialHallapiModel.MemorialHallType == 1) {
              that.isAdd = true;
            } else {
              that.isAdd = false;
            }
          },
          (err) => {}
        );
    },
  },
  created() {
    var that = this;
    if (this.$route.query.id == this.$store.state.mid) {
      this.input.MemorialHallID = this.$store.state.muid;
    }
    this.getMemorialHall(this.$route.query.id);
    this.init();
  },
};
</script>

<style scoped>
</style>
